import styled from "styled-components";

export const HeaderWrapper = styled.div``;

export const HeaderTitle = styled.div`
  background-image: linear-gradient(30deg, #0d5fbe 0%, #0d5fbe 100%);
  min-height: 38px;
  height: auto;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  display: flex;
  align-items: center;
  padding-left: 14px;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  font-size: ${({ theme }) => theme.fontSizes.font6} !important;
  text-align: left;
  @media (max-width: 768px) {
    height: auto;
    font-size: ${({ theme }) => theme.fontSizes.font7} !important;
    padding: 10px;
  }
`;

export const FilterWrapper = styled.div`
  padding: 8px 0px;
  position: relative;
  z-index: 2;
`;

export const LoginRecordsStyle = styled.div`
  margin: 15px auto;
`;

export const StyledCol = styled.div`
  text-align: left;
  margin-top: 20px;
  margin-bottom: 8px;
  display: flex;
  flex: 0 17%;
  @media screen and (max-width: 1100px) {
    padding-right: 14px;
    padding-left: 14px;
  }

  button[title="Apply Filter"] {
    padding: initial;
    width: 100%;
  }
`;

export const ContentDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: minmax(60px, auto);
  grid-gap: 0px 24px;
  @media screen and (max-width: 1100px) {
    display: block;
  }
`;

export const ItemDiv = styled.div`
  &:nth-child(8) {
    grid-column: span 2;
  }
  &:nth-child(9) {
    /* grid-column: 4 / span 2; */
    text-align: end;
    padding-top: 20px;
  }
`;
